import { Typography, Box, Theme } from "@mui/material";
import { StatusBadge } from "../../atoms/StatusBadge";
import { FairoTrace } from "../../models/types";
import { ColoredBadge } from "../../molecules/ColoredBadge";
import { IColumnVisibility } from "../../molecules/ColumnVisibility";
import { capitalizeFirstLetter, dateDisplayWithTime } from "../UIHelper";
import { TableTextWithEllipsis } from "../../molecules/TableTextWithEllipsis";
import { RunnableReadOnlyCustomField } from "../../molecules/custom-fields/RunnableCustomField";
import { DeploymentReadOnlyCustomField } from "../../molecules/custom-fields/DeploymentCustomField";

export const tracesColumnsVisibility = ({
  theme,
  bigTable = true,
}: {
  theme: Theme;
  bigTable?: boolean;
}): IColumnVisibility<FairoTrace>[] => [
  {
    field: "request_id",
    headerName: "Trace ID",
    visible: true,
    columnMinWidth: bigTable ? 300 : 100,
    columnMaxWidth: bigTable ? 300 : 100,
    renderer: (trace) => (
      <Box maxWidth={bigTable ? "300px" : "100px"}>
        <TableTextWithEllipsis value={trace.request_id} fullWidth={false} />
      </Box>
    ),
  },
  {
    field: "timestamp_ms",
    headerName: "Time Created",
    visible: true,
    columnMaxWidth: 180,
    columnMinWidth: 180,
    renderer: (trace) => (
      <Typography variant="body2">
        {dateDisplayWithTime(new Date(trace.timestamp_ms).toISOString())}
      </Typography>
    ),
  },
  {
    field: "status",
    headerName: "Status",
    visible: true,
    columnMaxWidth: 120,
    columnMinWidth: 120,
    renderer: (trace) => <StatusBadge status={trace.status as any} />,
  },
  {
    field: "execution_time_ms",
    headerName: "Execution Time",
    visible: true,
    columnMaxWidth: 130,
    columnMinWidth: 130,
    renderer: (trace) => (
      <Typography variant="body2">
        {trace.execution_time_ms ? `${(trace.execution_time_ms / 1000).toFixed(1)}s` : "-"}
      </Typography>
    ),
  },
  {
    field: "experiment_name",
    headerName: "Tags",
    visible: true,
    columnMinWidth: 400,
    renderer: (trace) => (
      <Box padding="4px" display="flex" flexWrap="wrap" gap="8px" maxWidth="100%">
        {trace.environment && (
          <ColoredBadge
            name={`environment: ${trace.environment}`}
            color={{
              background: theme.palette.custom.primaryStatusBackgroundColor,
              typography: theme.palette.custom.primaryStatusColor,
            }}
          />
        )}
        {trace.experiment_name &&
          trace.experiment_name !== "Production Default" &&
          trace.experiment_name !== "Development Default" && (
            <ColoredBadge
              name={`experiment: ${capitalizeFirstLetter(trace.experiment_name)}`}
              color={{
                background: theme.palette.custom.purple[100],
                typography: theme.palette.custom.purple[700],
              }}
            />
          )}
        {trace.runnable_id && (
          <RunnableReadOnlyCustomField
            value={[trace.runnable_id]}
            showRunnableTitle
            emptyState={false}
            textTransform="none"
            capitalize
          />
        )}
        {trace.deployment_id && (
          <DeploymentReadOnlyCustomField
            value={[trace.deployment_id]}
            showDeploymentTitle
            textTransform="none"
            capitalize
          />
        )}
      </Box>
    ),
  },
];
